import getWorkflowStepBranchGroups from '@/lib/workflows/getWorkflowStepBranchGroups.js';

const flattenWorkflowSteps = (steps, acc = []) => {
  if (!Array.isArray(steps)) {
    return acc;
  }

  for (const step of steps) {
    if (!step || typeof step !== 'object') {
      continue;
    }
    acc.push(step);
    if (Array.isArray(step.children) && step.children.length > 0) {
      flattenWorkflowSteps(step.children, acc);
    }
    for (const branch of getWorkflowStepBranchGroups(step)) {
      if (branch.steps.length > 0) {
        flattenWorkflowSteps(branch.steps, acc);
      }
    }
  }

  return acc;
};

export default flattenWorkflowSteps;
